<template>
  <div>
    <CustomPagination
      class="hidden lg:flex mt-10"
      :total-results-amount="totalResultsAmount"
      :per-page="perPage"
      @on-page-change="onPageChange"
    />
    <LoadMorePagination
      class="mt-10 py-3 mb-28 lg:hidden"
      :total-results-amount="totalResultsAmount"
      :per-page="perPage"
      @on-load-more="onLoadMore"
    />
  </div>
</template>

<script lang="ts">

import {
  PAGINATION_DEFAULT_RESULTS_LIMIT,
  RATING_REVIEWS_SECTION_SELECTOR,
  REVIEW_ID,
} from '~~/constants/pagination';

import type { UpdatePaginationPageParams } from '~~/types/pagination';
import { scrollToSection } from '~~/helpers/scroll/scrollToSection';

export default defineComponent({
  name: 'PaginationReviews',

  props: {
    totalResultsAmount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: PAGINATION_DEFAULT_RESULTS_LIMIT,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const productIdRef = toRef(props, 'productId');

    const {
      search: searchReviews,
    } = useReviewExtended(productIdRef);

    const { stickyAnchorNavHeight } = useAnchorNavigationStore();

    const onPageChange = (pageChangeParams: UpdatePaginationPageParams) => {

      scrollToSection(RATING_REVIEWS_SECTION_SELECTOR, -stickyAnchorNavHeight.value);
      updatePage(pageChangeParams);

    };

    const onLoadMore = async (pageChangeParams: UpdatePaginationPageParams) => {

      await updatePage(pageChangeParams);
      scrollToSection(`#${REVIEW_ID}-${pageChangeParams.limit - props.perPage}`);

    };

    const updatePage = async (pageChangeParams: UpdatePaginationPageParams) => {

      await searchReviews(pageChangeParams);

    };

    return {
      onPageChange,
      onLoadMore,
      RATING_REVIEWS_SECTION_SELECTOR,
    };

  },
});

</script>
